export enum UploadMessages {
  ONLY_PDF_FILES = "Only PDF files are allowed",
  LESS_THAN_5_MB = "File size must be less than 5MB",
  LESS_THAN_10_MB = "File size must be less than 10MB",
}
